import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

const SIM_CARDS_TABS = {
    SIM_CARDS:
    {
        name: 'sim_cards',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.SIM_LIST.name] })
    },
    SIM_GROUPS:
    {
        name: 'sim_groups',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.SIM_LIST.name] })
    }
};

SIM_CARDS_TABS.DEFAULT = SIM_CARDS_TABS.SIM_CARDS;

export default SIM_CARDS_TABS;